import React from 'react'
import './header.css'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'
import a_img from "../../assets/a_img.png"
const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5> Hello I'm</h5>
        <h1> Elgun</h1>
        <h5 className='text-light'> Fullstack Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className='me'>
        <img src={a_img} alt="a_img" />
        </div>
        <a href="#contact" className='scroll__down'>Scroll down</a>
      </div>
    </header>
  )
}

export default Header